import axios from 'axios';
import * as actionTypes from './actionTypes';
import apiCall from '../app/apiCall';

export const fetchActivitiesRequest = () => ({
  type: actionTypes.FETCH_ACTIVITIES_REQUEST
});
export const fetchActivitiesFailure = message => ({
  type: actionTypes.FETCH_ACTIVITIES_FAILURE,
  message
});
export const fetchActivitiesSuccess = activities => ({
  type: actionTypes.FETCH_ACTIVITIES_SUCCESS,
  activities
});
export const updateCalendarActivities = activities => ({
  type: actionTypes.UPDATE_CALENDAR_ACTIVITIES,
  activities
});

export function activitySave(activityId, data) {
  return () => {
    const activitySaveUrl = `activities/${activityId}`;
    return apiCall(activitySaveUrl, 'put', data);
  };
}

export function fetchActivities(
  staffId,
  startDate,
  endDate,
  bidSessionId,
  categoryId
) {
  return dispatch => {
    dispatch(fetchActivitiesRequest());

    function getActivities() {
      // Params to request bids and preferences.
      const activitiesRequestUrl = 'activities/preassignments';
      const activityTypesRequestUrl = 'activities/types';
      const data = {
        staffId,
        startDate,
        endDate,
        bidSessionId,
        categoryId
      };

      // Request
      axios
        .all([
          apiCall(activitiesRequestUrl, 'post', data),
          apiCall(activityTypesRequestUrl)
        ])
        .then(
          axios.spread((preassigments, actTypes) => {
            const activities = preassigments.data;
            const typesArr = actTypes.data.entries;
            const types = new Map();
            typesArr.map(type => {
              types.set(type.activityTypeId, type.backgroundColorHex);
              return type;
            });
            return dispatch(fetchActivitiesSuccess({ activities, types }));
          })
        )
        .catch(error => dispatch(fetchActivitiesFailure(error)));
    }
    getActivities();
  };
}

export const fetchOtherOptions = (
  staffId,
  bidSessionId,
  categoryId
) => {
  return () => {
    const getOtherOptionsUrl = `preferences/options/other?bidsession_id=${bidSessionId}&staff_id=${staffId}&category_id=${categoryId}`;
    return apiCall(getOtherOptionsUrl)
  };
}

export function updateCalendar(activities) {
  return dispatch => {
    dispatch(updateCalendarActivities({ activities }));
  };
}

export function checkLegalityService(
  bidSessionId,
  categoryId,
  staffId,
  activitiesIds
) {
  return () => {
    const activityDetailsRequestUrl = `activities/bid-session/${bidSessionId}/category/${categoryId}/employee/${staffId}/legality`;
    return apiCall(activityDetailsRequestUrl, 'post', activitiesIds);
  };
}

export function getStatistics(bidSessionId, categoryId, staffId) {
  return () => {
    const statisticsUrl = `preferences/statistics/bid-session/${bidSessionId}/category/${categoryId}/employee/${staffId}`;
    return apiCall(statisticsUrl, 'get');
  };
}

export function removeActivity(activityId) {
  return dispatch => {
    dispatch({
      type: actionTypes.REMOVE_ACTIVITY,
      activityId
    });
  };
}

export function updateActivity(activity) {
  return dispatch => {
    dispatch({
      type: actionTypes.UPDATE_ACTIVITY,
      activity
    });
  };
}
